import { useState, useEffect, useRef } from 'react';

/*
 * - useRef: Una referencia directa al elemento <img> para forzar la actualización del src de forma imperativa.
 * - En lugar de guardar la URL completa, solo guardamos el timestamp
 * - Dos useEffect:
 *   -- Uno maneja el intervalo (sin dependencias adicionales)
 *   -- Otro actualiza el src de la imagen cuando cambia el timestamp o la URL
 * - Actualización imperativa: Al modificar directamente imgRef.current.src, se garantiza
 *   que el navegador recargue la imagen, evitando problemas de caché.
 * 
 * https://ocan.iac.es/meteo/getfile.php?d=latest&file=Can01r4
 */


function Meteosat({ webcamUrl, title }) {


  return (
<div>
  <p>Images and movies are subject to <a href="http://www.eumetsat.int/" target="_blank" rel="noopener noreferrer">EUMETSAT</a> Copyright and they <strong>CANNOT BE PUBLISHED</strong> outside IAC.</p>
  <p class="text-center"><span class="btn btn-default"><a href="https://masif.eumetsat.int/ossi/webpages/about.html" target="_blank" rel="noopener noreferrer">Check status</a></span></p>
  <p>[OOCC-page page="meteosat-updated"]</p>

   

  <div className='row text-center'>

    <div className='col-md-4'>
      ZOOM 5
      <a href="https://ocan.iac.es/meteo/getfile.php?d=latest&file=Nat321r5">
        <img src="https://ocan.iac.es/meteo/getfile.php?d=latest&file=Nat321r5_preview" />
      </a>
    </div>

    <div className='col-md-4'>
      ZOOM 4
      <a href="https://ocan.iac.es/meteo/getfile.php?d=latest&file=Nat321r4">
        <img src="https://ocan.iac.es/meteo/getfile.php?d=latest&file=Nat321r4_preview" />
      </a>
    </div>

    <div className='col-md-4'>
      MOVIES
      <img src="https://ocan.iac.es/meteo/getfile.php?d=latest&file=Nat321r5_preview" /> <br />

      <a href="https://ocan.iac.es/meteo/getfile.php?d=movies&file=movNatr5">ZOOM 5 movie</a> -
      <a href="https://ocan.iac.es/meteo/getfile.php?d=movies&file=movNatr4">ZOOM 4 movie</a>
    </div>
  </div>


  <hr />







  
  <table>
  <tbody>
  <tr>
  <th colspan="2" scope="col">COMPOSITE IMAGES</th>
  <th rowspan="2" scope="col" width="25%">MOVIES</th>
  </tr>
  <tr>
  <td width="25%">
  <div align="center">ZOOM 5</div>
  </td>
  <td width="25%">
  <div align="center">ZOOM 4</div>
  </td>
  </tr>
  <tr>
  <td>
  <div align="center"><a href="https://research.iac.es/OOCC/Eumetsat/latest/Nat321r5.jpg"><img src="https://research.iac.es/OOCC/Eumetsat/latest/Nat321r5_preview.jpg" width="250" height="201" border="0" /></a></div>
  </td>
  <td>
  <div align="center"><a href="https://research.iac.es/OOCC/Eumetsat/latest/Nat321r4.jpg"><img src="https://research.iac.es/OOCC/Eumetsat/latest/Nat321r4_preview.jpg" width="250" height="201" border="0" /></a></div>
  </td>
  <td rowspan="2">
  <div align="center"><img src="https://research.iac.es/OOCC/Eumetsat/latest/Nat321r5_preview.jpg" width="200" height="161" border="0" /><br />
  <a href="https://research.iac.es/OOCC/Eumetsat/movies/movNatr5.mp4">ZOOM 5 movie</a> - <a href="https://research.iac.es/OOCC/Eumetsat/movies/movNatr4.mp4">ZOOM 4 movie</a></div>
  <div align="center"> </div>
  </td>
  </tr>
  <tr>
  <td colspan="2">
  <div align="center">Day-time - RGB colour composite of the channels 3 (1.6µ) - 2 (0.8µ) - 1 (0.6µ)</div>
  <div align="center"> </div>
  </td>
  </tr>
  <tr>
  <td>
  <div align="center"><a href="https://research.iac.es/OOCC/Eumetsat/latest/Night-4-7-9r5.jpg"><img src="https://research.iac.es/OOCC/Eumetsat/latest/Night-4-7-9r5_preview.jpg" width="250" height="201" border="0" /></a></div>
  </td>
  <td>
  <div align="center"><a href="https://research.iac.es/OOCC/Eumetsat/latest/Night-4-7-9r4.jpg"><img src="https://research.iac.es/OOCC/Eumetsat/latest/Night-4-7-9r4_preview.jpg" width="250" height="201" border="0" /></a></div>
  </td>
  <td rowspan="2">
  <div align="center"><img src="https://research.iac.es/OOCC/Eumetsat/latest/Night-4-7-9r5_preview.jpg" width="200" height="161" border="0" /><br />
  <a href="https://research.iac.es/OOCC/Eumetsat/movies/movNigr5.mp4">ZOOM 5 movie</a> - <a href="https://research.iac.es/OOCC/Eumetsat/movies/movNigr4.mp4">ZOOM 4 movie</a></div>
  <div align="center"> </div>
  </td>
  </tr>
  <tr>
  <td colspan="2">
  <div align="center">Night-time - RGB colour composite of the channels 4 (3.9µ) - 7 (8.7µ) - 9 (10.8µ)</div>
  <div align="center"> </div>
  </td>
  </tr>
  <tr>
  <td>
  <div align="center"><a href="https://research.iac.es/OOCC/Eumetsat/latest/Flowr5.jpg"><img src="https://research.iac.es/OOCC/Eumetsat/latest/Flowr5_preview.jpg" width="250" height="201" border="0" /></a></div>
  </td>
  <td>
  <div align="center"><a href="https://research.iac.es/OOCC/Eumetsat/latest/Flowr4.jpg"><img src="https://research.iac.es/OOCC/Eumetsat/latest/Flowr4_preview.jpg" width="250" height="201" border="0" /></a></div>
  </td>
  <td rowspan="2">
  <div align="center"><img src="https://research.iac.es/OOCC/Eumetsat/latest/Flowr5_preview.jpg" width="200" height="161" border="0" /><br />
  <a href="https://research.iac.es/OOCC/Eumetsat/movies/movFlor5.mp4">ZOOM 5 movie</a> - <a href="https://research.iac.es/OOCC/Eumetsat/movies/movFlor4.mp4">ZOOM 4 movie</a></div>
  <div align="center"> </div>
  </td>
  </tr>
  <tr>
  <td colspan="2">
  <div align="center"><a href="http://oiswww.eumetsat.int/~idds/html/doc/airmass_interpretation.pdf">24 hours flow</a> - RGB colour composite of the channels [5-6] (6.2-7.3µ) - [8-9] (9.7-10.8µ) - [0-5] (6.2µ)</div>
  <div align="center"> </div>
  </td>
  </tr>
  </tbody>
  </table>
  <p>&nbsp;</p>
  <table border="1" width="66%" align="center">
  <tbody>
  <tr>
  <th colspan="5" scope="col">SINGLE IMAGES</th>
  </tr>
  <tr>
  <th scope="col">ZOOM 5</th>
  <th scope="col">ZOOM 4</th>
  <th scope="col"> </th>
  <th scope="col">ZOOM 5</th>
  <th scope="col">ZOOM 4</th>
  </tr>
  <tr>
  <td>
  <div align="center"><a href="https://research.iac.es/OOCC/Eumetsat/latest/Can01r5.jpg"><img src="https://research.iac.es/OOCC/Eumetsat/latest/Can01r5_preview.jpg" width="250" height="201" border="0" /></a></div>
  </td>
  <td>
  <div align="center"><a href="https://research.iac.es/OOCC/Eumetsat/latest/Can01r4.jpg"><img src="https://research.iac.es/OOCC/Eumetsat/latest/Can01r4_preview.jpg" width="250" height="201" border="0" /></a></div>
  </td>
  <td> </td>
  <td>
  <div align="center"><a href="https://research.iac.es/OOCC/Eumetsat/latest/Can02r5.jpg"><img src="https://research.iac.es/OOCC/Eumetsat/latest/Can02r5_preview.jpg" width="250" height="201" border="0" /></a></div>
  </td>
  <td>
  <div align="center"><a href="https://research.iac.es/OOCC/Eumetsat/latest/Can02r4.jpg"><img src="https://research.iac.es/OOCC/Eumetsat/latest/Can02r4_preview.jpg" width="250" height="201" border="0" /></a></div>
  </td>
  </tr>
  <tr>
  <td colspan="2">
  <div align="center">Channel 1: Visible 0.6µ</div>
  </td>
  <td> </td>
  <td colspan="2">
  <div align="center">Channel 2: Near Infrared 0.8µ</div>
  </td>
  </tr>
  <tr>
  <td>
  <div align="center"><a href="https://research.iac.es/OOCC/Eumetsat/latest/Can03r5.jpg"><img src="https://research.iac.es/OOCC/Eumetsat/latest/Can03r5_preview.jpg" width="250" height="201" border="0" /></a></div>
  </td>
  <td>
  <div align="center"><a href="https://research.iac.es/OOCC/Eumetsat/latest/Can03r4.jpg"><img src="https://research.iac.es/OOCC/Eumetsat/latest/Can03r4_preview.jpg" width="250" height="201" border="0" /></a></div>
  </td>
  <td> </td>
  <td>
  <div align="center"><a href="https://research.iac.es/OOCC/Eumetsat/latest/Can04r5.jpg"><img src="https://research.iac.es/OOCC/Eumetsat/latest/Can04r5_preview.jpg" width="250" height="201" border="0" /></a></div>
  </td>
  <td>
  <div align="center"><a href="https://research.iac.es/OOCC/Eumetsat/latest/Can04r4.jpg"><img src="https://research.iac.es/OOCC/Eumetsat/latest/Can04r4_preview.jpg" width="250" height="201" border="0" /></a></div>
  </td>
  </tr>
  <tr>
  <td colspan="2">
  <div align="center">Channel 3: Near Infrared 1.6µ</div>
  </td>
  <td> </td>
  <td colspan="2">
  <div align="center">Channel 4: 3.9µ</div>
  </td>
  </tr>
  <tr>
  <td>
  <div align="center"><a href="https://research.iac.es/OOCC/Eumetsat/latest/Can05r5.jpg"><img src="https://research.iac.es/OOCC/Eumetsat/latest/Can05r5_preview.jpg" width="250" height="201" border="0" /></a></div>
  </td>
  <td>
  <div align="center"><a href="https://research.iac.es/OOCC/Eumetsat/latest/Can05r4.jpg"><img src="https://research.iac.es/OOCC/Eumetsat/latest/Can05r4_preview.jpg" width="250" height="201" border="0" /></a></div>
  </td>
  <td> </td>
  <td>
  <div align="center"><a href="https://research.iac.es/OOCC/Eumetsat/latest/Can06r5.jpg"><img src="https://research.iac.es/OOCC/Eumetsat/latest/Can06r5_preview.jpg" width="250" height="201" border="0" /></a></div>
  </td>
  <td>
  <div align="center"><a href="https://research.iac.es/OOCC/Eumetsat/latest/Can06r4.jpg"><img src="https://research.iac.es/OOCC/Eumetsat/latest/Can06r4_preview.jpg" width="250" height="201" border="0" /></a></div>
  </td>
  </tr>
  <tr>
  <td colspan="2">
  <div align="center">Channel 5: Water Vapour 6.2µ</div>
  </td>
  <td> </td>
  <td colspan="2">
  <div align="center">Channel 6: Water Vapour 7.3µ</div>
  </td>
  </tr>
  <tr>
  <td>
  <div align="center"><a href="https://research.iac.es/OOCC/Eumetsat/latest/Can07r5.jpg"><img src="https://research.iac.es/OOCC/Eumetsat/latest/Can07r5_preview.jpg" width="250" height="201" border="0" /></a></div>
  </td>
  <td>
  <div align="center"><a href="https://research.iac.es/OOCC/Eumetsat/latest/Can07r4.jpg"><img src="https://research.iac.es/OOCC/Eumetsat/latest/Can07r4_preview.jpg" width="250" height="201" border="0" /></a></div>
  </td>
  <td> </td>
  <td>
  <div align="center"><a href="https://research.iac.es/OOCC/Eumetsat/latest/Can08r5.jpg"><img src="https://research.iac.es/OOCC/Eumetsat/latest/Can08r5_preview.jpg" width="250" height="201" border="0" /></a></div>
  </td>
  <td>
  <div align="center"><a href="https://research.iac.es/OOCC/Eumetsat/latest/Can08r4.jpg"><img src="https://research.iac.es/OOCC/Eumetsat/latest/Can08r4_preview.jpg" width="250" height="201" border="0" /></a></div>
  </td>
  </tr>
  <tr>
  <td colspan="2">
  <div align="center">Channel 7: 8.7µ</div>
  </td>
  <td> </td>
  <td colspan="2">
  <div align="center">Channel 8: Ozone 9.7µ</div>
  </td>
  </tr>
  <tr>
  <td>
  <div align="center"><a href="https://research.iac.es/OOCC/Eumetsat/latest/Can09r5.jpg"><img src="https://research.iac.es/OOCC/Eumetsat/latest/Can09r5_preview.jpg" width="250" height="201" border="0" /></a></div>
  </td>
  <td>
  <div align="center"><a href="https://research.iac.es/OOCC/Eumetsat/latest/Can09r4.jpg"><img src="https://research.iac.es/OOCC/Eumetsat/latest/Can09r4_preview.jpg" width="250" height="201" border="0" /></a></div>
  </td>
  <td> </td>
  <td>
  <div align="center"><a href="https://research.iac.es/OOCC/Eumetsat/latest/Can10r5.jpg"><img src="https://research.iac.es/OOCC/Eumetsat/latest/Can10r5_preview.jpg" width="250" height="201" border="0" /></a></div>
  </td>
  <td>
  <div align="center"><a href="https://research.iac.es/OOCC/Eumetsat/latest/Can10r4.jpg"><img src="https://research.iac.es/OOCC/Eumetsat/latest/Can10r4_preview.jpg" width="250" height="201" border="0" /></a></div>
  </td>
  </tr>
  <tr>
  <td colspan="2">
  <div align="center">Channel 9: 10.8µ</div>
  </td>
  <td> </td>
  <td colspan="2">
  <div align="center">Channel 10: 12.0µ</div>
  </td>
  </tr>
  <tr>
  <td>
  <div align="center"><a href="https://research.iac.es/OOCC/Eumetsat/latest/Can11r5.jpg"><img src="https://research.iac.es/OOCC/Eumetsat/latest/Can11r5_preview.jpg" width="250" height="201" border="0" /></a></div>
  </td>
  <td>
  <div align="center"><a href="https://research.iac.es/OOCC/Eumetsat/latest/Can11r4.jpg"><img src="https://research.iac.es/OOCC/Eumetsat/latest/Can11r4_preview.jpg" width="250" height="201" border="0" /></a></div>
  </td>
  <td> </td>
  <td colspan="2">
  <div align="center"><a href="https://research.iac.es/OOCC/Eumetsat/latest/Can12r5.jpg"><img src="https://research.iac.es/OOCC/Eumetsat/latest/Can12r5_preview.jpg" width="250" height="201" border="0" /></a></div>
  <div align="center"> </div>
  </td>
  </tr>
  <tr>
  <td colspan="2">
  <div align="center">Channel 11: CO2 13.4µ</div>
  </td>
  <td> </td>
  <td colspan="2">
  <div align="center">Channel 12: High Resolution Visible</div>
  </td>
  </tr>
  </tbody>
  </table>
</div>
  );
}

export default Meteosat;